import './preprocessObsidian';
import { useAsset } from '@artica/assets';
import generateMeshPreset from '../common/generateMeshPreset';
import brandedShapes from './brandedShapes.json';

export default function BrandedShapes() {
  const { nodes, materials } = useAsset('obsidian');

  return (
    <group position={ [-47.66, 17.2, -23.86] }>
      { brandedShapes.map(generateMeshPreset({
        nodes,
        materials,
        material: 'Obsidian',
      })) }
    </group>
  );
};